<ng-container [formGroup]="form">
  <ng-container formGroupName="coupon">
    <div class="form-group coupon" [hidden]="coupon?.disabled">
      <h3>{{ labels.payoff.coupon.coupon }}</h3>
      <div class="form-row">
        <div
          *ngIf="coupon.get('couponType') as couponType"
          class="form-group col-lg-2"
          [hidden]="couponType.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.coupon.couponType"
            [labelId]="'couponType'"
            [items]="couponTypeItems"
            closeOnSelect="true"
            formControlName="couponType"
            [readonly]="couponType.readOnly"
          ></app-dc-select>
        </div>
        <div
          *ngIf="coupon.get('performanceCalculation') as performanceCalculation"
          class="form-group col-lg-2"
          [hidden]="performanceCalculation.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.coupon.performanceCalculation"
            [labelId]="'performanceCalculation'"
            [items]="PERFORMANCE_CALCULATION_TYPES"
            closeOnSelect="true"
            formControlName="performanceCalculation"
            [readonly]="performanceCalculation.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="coupon.get('restrike') as restrike"
          class="form-group col-lg-1"
          [hidden]="restrike.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.coupon.restrike"
            [labelId]="'restrike'"
            [items]="YES_NO"
            closeOnSelect="true"
            formControlName="restrike"
            [readonly]="restrike.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="coupon.get('frequency') as couponFrequency"
          class="form-group col-lg-1"
          [hidden]="couponFrequency.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.coupon.frequency"
            [labelId]="'frequency1'"
            [items]="frequencyItems"
            closeOnSelect="true"
            formControlName="frequency"
            [readonly]="couponFrequency.readOnly"
            [searchable]="true"
            [FreeText]="true"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="coupon.get('barrierBreak') as couponBarrierBreak"
          class="form-group col-lg-2"
          [hidden]="couponBarrierBreak.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.coupon.barrierBreak"
            [labelId]="'barrierBreak'"
            [items]="barrierBreakItems"
            closeOnSelect="true"
            formControlName="barrierBreak"
            [readonly]="couponBarrierBreak.readOnly"
          ></app-dc-select>
        </div>
        <div
          *ngIf="coupon.get('conversionOnRedemption') as conversionOnRedemption"
          class="form-group col-lg-2"
          [hidden]="conversionOnRedemption.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.coupon.conversionOnRedemption"
            [labelId]="'conversionOnRedemption'"
            [items]="YES_NO"
            closeOnSelect="true"
            formControlName="conversionOnRedemption"
            [readonly]="conversionOnRedemption.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
      </div>
      <div class="form-row">
        <div
          *ngIf="coupon.get('fixedPeriods') as fixedPeriods"
          class="form-group col-lg-2"
          [hidden]="fixedPeriods.disabled"
        >
          <app-dc-input
            [label]="labels.payoff.coupon.fixedPeriods"
            [id]="'fixedPeriods'"
            type="text"
            formControlName="fixedPeriods"
            [readonly]="fixedPeriods.readOnly"
          ></app-dc-input>
        </div>
        <div
          *ngIf="coupon.get('floatingPeriods') as floatingPeriods"
          class="form-group col-lg-2"
          [hidden]="floatingPeriods.disabled"
        >
          <app-dc-input
            [label]="labels.payoff.coupon.floatingPeriods"
            [id]="'floatingPeriods'"
            type="text"
            formControlName="floatingPeriods"
            [readonly]="floatingPeriods.readOnly"
          ></app-dc-input>
        </div>
        <div
          *ngIf="coupon.get('fixedRate') as fixedRate"
          class="form-group col-lg-3"
          [hidden]="fixedRate.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.fixedRate"
            [id]="'fixedRate'"
            formControlName="fixedRate"
            [readonly]="fixedRate.readOnly"
            defaultUnit="pct"
            [helpText]="'Annualised Rate'"
            [minMaxIndicativeToggle]="true"
            componentKey="772b42fd-e454-4c66-88d9-bfa96a60f694"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <div
          *ngIf="coupon.get('referenceRate') as referenceRate"
          class="form-group col-lg-2"
          [hidden]="referenceRate.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.coupon.referenceRate"
            [labelId]="'referenceRate'"
            [items]="referenceRateItems"
            closeOnSelect="true"
            formControlName="referenceRate"
            [readonly]="referenceRate.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
      </div>
      <div class="form-row">
        <div
          *ngIf="coupon.get('rangeAccrualRate') as rangeAccrualRate"
          class="form-group col-lg-3"
          [hidden]="rangeAccrualRate.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.rangeAccrualRate"
            [id]="'rangeAccrualRate'"
            formControlName="rangeAccrualRate"
            [readonly]="rangeAccrualRate.readOnly"
            defaultUnit="pct"
            [helpText]="'Annualised Rate'"
            [minMaxIndicativeToggle]="true"
            componentKey="8df0edea-4c32-5422-ac28-bbb864f5c887"
          ></app-dc-input-number-percent-indicative-final>
        </div>
      </div>
      <div class="form-row">
        <div
          *ngIf="coupon.get('multiplier') as multiplier"
          class="form-group col-lg-2"
          [hidden]="multiplier.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.multiplier"
            [id]="'multiplier'"
            formControlName="multiplier"
            [readonly]="multiplier.readOnly"
            defaultUnit="pct"
            [minMaxIndicativeToggle]="false"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <div
          *ngIf="coupon.get('strike') as strike"
          class="form-group col-lg-2"
          [hidden]="strike.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.strike"
            [id]="'strike'"
            formControlName="strike"
            [readonly]="strike.readOnly"
            defaultUnit="pct"
            [minMaxIndicativeToggle]="true"
            componentKey="h8fd1709-7025-1x32-145h-y0g0128d325a1"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <div
          *ngIf="coupon.get('spread') as spread"
          class="form-group col-lg-2"
          [hidden]="spread.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.spread"
            [id]="'spread'"
            formControlName="spread"
            [readonly]="spread.readOnly"
            defaultUnit="pct"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <ng-container *ngIf="productType.value">
          <div
            *ngIf="coupon.get('digitalStrike') as digitalStrike"
            class="form-group col-lg-2"
            [hidden]="digitalStrike.disabled"
          >
            <app-dc-input-number-percent-indicative-final
              [label]="labels.payoff.coupon.digitalStrike"
              [id]="'digitalStrike'"
              formControlName="digitalStrike"
              [readonly]="digitalStrike.readOnly"
              [defaultUnit]="
                productType.value === 'PRDC' ||
                productType.value === 'PERFORMANCE_LINKED_COUPON'
                  ? 'abs'
                  : 'pct'
              "
              [minMaxIndicativeToggle]="true"
              componentKey="b6ce9982-7025-1x32-145h-y0g0128d325a1"
            ></app-dc-input-number-percent-indicative-final>
          </div>
        </ng-container>
        <div
          *ngIf="coupon.get('digitalAmount') as digitalAmount"
          class="form-group col-lg-2"
          [hidden]="digitalAmount.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.digitalAmount"
            [id]="'digitalAmount'"
            formControlName="digitalAmount"
            [readonly]="digitalAmount.readOnly"
            defaultUnit="pct"
            [minMaxIndicativeToggle]="false"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <div
          *ngIf="coupon.get('floor') as floor"
          class="form-group col-lg-2"
          [hidden]="floor.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.floor"
            [id]="'floor'"
            formControlName="floor"
            [readonly]="floor.readOnly"
            defaultUnit="pct"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <div
          *ngIf="coupon.get('cap') as cap"
          class="form-group col-lg-2"
          [hidden]="cap.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.cap"
            [id]="'cap'"
            formControlName="cap"
            [readonly]="cap.readOnly"
            defaultUnit="pct"
          ></app-dc-input-number-percent-indicative-final>
        </div>
      </div>
      <div class="form-group">
        <div class="form-row">
          <div
            *ngIf="coupon.get('rateReset') as rateReset"
            class="form-group col-lg-2"
            [hidden]="rateReset.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.rateReset"
              [labelId]="'rateReset'"
              [items]="rateResetItems"
              closeOnSelect="true"
              formControlName="rateReset"
              [readonly]="rateReset.readOnly"
              [clearSelection]="true"
            ></app-dc-select>
          </div>
          <div
            *ngIf="coupon.get('rateCalculationMethod') as rateCalculationMethod"
            class="form-group col-lg-2"
            [hidden]="rateCalculationMethod.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.rateCalculationMethod"
              [labelId]="'rateCalculationMethod'"
              [items]="rateCalculationMethodItems"
              closeOnSelect="true"
              formControlName="rateCalculationMethod"
              [readonly]="rateCalculationMethod.readOnly"
            ></app-dc-select>
          </div>
          <div
            *ngIf="
              coupon.get(
                'rateResetSuspensionLength'
              ) as rateResetSuspensionLength
            "
            class="form-group col-lg-1"
            [hidden]="rateResetSuspensionLength.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.rateResetSuspensionLength"
              [labelId]="'rateResetSuspensionLength'"
              [items]="rateSuspensionPeriodsOptions"
              closeOnSelect="true"
              formControlName="rateResetSuspensionLength"
              [readonly]="rateResetSuspensionLength.readOnly"
            ></app-dc-select>
          </div>
          <div
            *ngIf="coupon.get('suspensionLength') as suspensionLength"
            class="form-group col-lg-1"
            [hidden]="suspensionLength.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.rateResetSuspensionLength"
              [labelId]="'suspensionLength'"
              [items]="rateSuspensionPeriodsOptions"
              closeOnSelect="true"
              formControlName="suspensionLength"
              [readonly]="suspensionLength.readOnly"
            ></app-dc-select>
          </div>
          <div
            *ngIf="
              coupon.get('rateResetLookbackShift') as rateResetLookbackShift
            "
            class="form-group col-lg-1"
            [hidden]="rateResetLookbackShift.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.rateResetLookbackShift"
              [labelId]="'rateResetLookbackShift'"
              [items]="rateBusinessDaysOptions"
              closeOnSelect="true"
              formControlName="rateResetLookbackShift"
              [readonly]="rateResetLookbackShift.readOnly"
            ></app-dc-select>
          </div>
          <div
            *ngIf="
              coupon.get(
                'rateObservationPeriodShift'
              ) as rateObservationPeriodShift
            "
            class="form-group col-lg-1"
            [hidden]="rateObservationPeriodShift.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.rateObservationPeriodShift"
              [labelId]="'rateObservationPeriodShift'"
              [items]="rateBusinessDaysOptions"
              closeOnSelect="true"
              formControlName="rateObservationPeriodShift"
              [readonly]="rateObservationPeriodShift.readOnly"
            ></app-dc-select>
          </div>
          <div
            *ngIf="
              coupon.get(
                'rateObsPeriodShiftExtraCalendars'
              ) as rateObsPeriodShiftExtraCalendars
            "
            class="form-group col-lg-3"
            [hidden]="rateObsPeriodShiftExtraCalendars.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.rateObsPeriodShiftExtraCalendars"
              [labelId]="'rateObsPeriodShiftExtraCalendars'"
              [items]="settlementCalendars"
              closeOnSelect="true"
              formControlName="rateObsPeriodShiftExtraCalendars"
              [readonly]="rateObsPeriodShiftExtraCalendars.readOnly"
              [clearSelection]="true"
              [multiple]="true"
              [checkbox]="true"
              [closeOnSelect]="false"
            ></app-dc-select>
          </div>
          <ng-container formGroupName="barrier">
            <div
              *ngIf="couponBarrier.get('type') as couponBarrierType"
              class="form-group col-lg-2"
              [hidden]="couponBarrierType.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.coupon.barrier.type"
                [labelId]="'couponBarrierType'"
                [items]="
                  couponBarrierType.options ?? BARRIER_AMOUNT_WITH_CUSTOM
                "
                closeOnSelect="true"
                formControlName="type"
                [readonly]="couponBarrierType.readOnly"
                [clearSelection]="!productType?.value === 'RANGE_ACCRUAL'"
              ></app-dc-select>
            </div>
            <div
              *ngIf="couponBarrier.get('level') as couponBarrier"
              class="form-group col-lg-3"
              [hidden]="couponBarrier.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.coupon.barrier.level"
                [id]="'couponBarrier'"
                formControlName="level"
                [readonly]="couponBarrier.readOnly"
                defaultUnit="pct"
                [minMaxIndicativeToggle]="true"
                componentKey="b6bd0182-7025-5b56-960a-f7d311d704a3"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="couponBarrier.get('stepSize') as couponBarrierStepSize"
              class="form-group col-lg-2"
              [hidden]="couponBarrierStepSize.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.coupon.barrier.stepSize"
                [id]="'couponBarrierStepSize'"
                formControlName="stepSize"
                [readonly]="couponBarrierStepSize.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="couponBarrier.get('obsFrequency') as couponObvsFrequency"
              class="form-group col-lg-2"
              [hidden]="couponObvsFrequency.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.coupon.barrier.obsFrequency"
                [labelId]="'couponObvsFrequency'"
                [items]="OBS_FREQUENCY"
                closeOnSelect="true"
                formControlName="obsFrequency"
                [readonly]="couponObvsFrequency.readOnly"
                [clearSelection]="true"
              ></app-dc-select>
            </div>
            <div
              *ngIf="couponBarrier.get('touchAndBreak') as couponTouchBreak"
              class="form-group col-lg-1"
              [hidden]="couponTouchBreak.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.coupon.barrier.touchAndBreak"
                [labelId]="'couponTouchBreak'"
                [items]="YES_NO"
                closeOnSelect="true"
                formControlName="touchAndBreak"
                [readonly]="couponTouchBreak.readOnly"
                [clearSelection]="true"
              ></app-dc-select>
            </div>
          </ng-container>
        </div>
        <div class="form-row">
          <div
            *ngIf="coupon.get('couponCalculationDays') as couponCalculationDays"
            class="form-group col-lg-2"
            [hidden]="couponCalculationDays.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.couponCalculationDays"
              [labelId]="'couponCalculationDays'"
              [items]="couponCalculationDaysItems"
              closeOnSelect="true"
              formControlName="couponCalculationDays"
              [readonly]="couponCalculationDays.readOnly"
            ></app-dc-select>
          </div>
          <div
            *ngIf="coupon.get('dayCount') as dayCount"
            class="form-group col-lg-2"
            [hidden]="dayCount.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.dayCountBasis"
              [labelId]="'dayCount'"
              [items]="dayCountItems"
              closeOnSelect="true"
              formControlName="dayCount"
              [readonly]="dayCount.readOnly"
              [searchable]="true"
            ></app-dc-select>
          </div>
          <div
            *ngIf="coupon.get('rateInterpolation') as rateInterpolation"
            class="form-group col-lg-2"
            [hidden]="rateInterpolation.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.coupon.rateInterpolation"
              [labelId]="'rateInterpolation'"
              [items]="rateInterpolationItems"
              closeOnSelect="true"
              formControlName="rateInterpolation"
              [readonly]="rateInterpolation.readOnly"
              [clearSelection]="true"
              [searchable]="false"
            ></app-dc-select>
          </div>
        </div>
        <div class="form-row">
          <ng-container formGroupName="barrier">
            <div
              *ngIf="couponBarrier.get('lowerLevel') as couponLowerLevel"
              class="form-group col-lg-2"
              [hidden]="couponLowerLevel.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.coupon.barrier.lowerLevel"
                [id]="'lowerLevel'"
                formControlName="lowerLevel"
                [readonly]="couponLowerLevel.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="couponBarrier.get('lowerStepSize') as couponLowerStepSize"
              class="form-group col-lg-2"
              [hidden]="couponLowerStepSize.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.coupon.barrier.lowerStepSize"
                [id]="'lowerStepSize'"
                formControlName="lowerStepSize"
                [readonly]="couponLowerStepSize.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="couponBarrier.get('upperLevel') as couponUpperLevel"
              class="form-group col-lg-2"
              [hidden]="couponUpperLevel.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.coupon.barrier.upperLevel"
                [id]="'upperLevel'"
                formControlName="upperLevel"
                [readonly]="couponUpperLevel.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="couponBarrier.get('upperStepSize') as couponUpperStepSize"
              class="form-group col-lg-2"
              [hidden]="couponUpperStepSize.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.coupon.barrier.upperStepSize"
                [id]="'upperStepSize'"
                formControlName="upperStepSize"
                [readonly]="couponUpperStepSize.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="form-row">
        <div
          *ngIf="coupon.get('memory') as memory"
          class="form-group col-lg-1"
          [hidden]="memory.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.coupon.memory"
            [labelId]="'memory'"
            [items]="YES_NO"
            closeOnSelect="true"
            formControlName="memory"
            [readonly]="memory.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
      </div>

      <div class="form-row">
        <div
          *ngIf="coupon.get('conditionalRate') as conditionalRate"
          class="form-group col-lg-2"
          [hidden]="conditionalRate.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.conditionalRate"
            [id]="'conditionalRate'"
            formControlName="conditionalRate"
            [readonly]="conditionalRate.readOnly"
            [lockDefault]="true"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <div
          *ngIf="
            coupon.get('conditionalCouponStrike') as conditionalCouponStrike
          "
          class="form-group col-lg-2"
          [hidden]="conditionalCouponStrike.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.coupon.conditionalCouponStrike"
            [id]="'conditionalCouponStrike'"
            formControlName="conditionalCouponStrike"
            [readonly]="conditionalCouponStrike.readOnly"
            defaultUnit="abs"
          ></app-dc-input-number-percent-indicative-final>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container formGroupName="participation">
    <div class="form-group" [hidden]="participation.disabled">
      <h3>{{ labels.payoff.participation.participation }}</h3>

      <ng-container formGroupName="upside" *ngIf="!upside.disabled">
        <div class="form-group">
          <div class="form-row">
            <div
              *ngIf="upside.get('type') as type"
              class="form-group col-lg-2"
              [hidden]="type.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.participation.upside.type"
                [labelId]="'type'"
                [items]="upsideTypeItems"
                closeOnSelect="true"
                formControlName="type"
                [readonly]="type.readOnly"
              ></app-dc-select>
            </div>
            <div
              *ngIf="upside.get('callStrike') as callStrike"
              class="form-group col-lg-2"
              [hidden]="callStrike.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="
                  upside.get('type').value | dynamicStrikeLabelPipe: labels
                "
                [id]="'callStrike'"
                formControlName="callStrike"
                [readonly]="callStrike.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="upside.get('callParticipation') as callParticipation"
              class="form-group col-lg-3"
              [hidden]="callParticipation.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.upside.callParticipation"
                [id]="'callParticipation'"
                formControlName="callParticipation"
                [readonly]="callParticipation.readOnly"
                defaultUnit="pct"
                [minMaxIndicativeToggle]="true"
                componentKey="d5a6d128-5813-5f8c-9807-3a4c3c3cfe5d"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="upside.get('callSpreadStrike') as callSpreadStrike"
              class="form-group col-lg-2"
              [hidden]="callSpreadStrike.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.upside.callSpreadStrike"
                [id]="'callSpreadStrike'"
                formControlName="callSpreadStrike"
                [readonly]="callSpreadStrike.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="upside.get('digitalAmount') as digitalAmount"
              class="form-group col-lg-2"
              [hidden]="digitalAmount.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.upside.digitalAmount"
                [id]="'digitalAmount'"
                formControlName="digitalAmount"
                [readonly]="digitalAmount.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
          </div>

          <div class="form-row">
            <div
              *ngIf="upside.get('putStrike') as putStrike"
              class="form-group col-lg-2"
              [hidden]="putStrike.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.upside.putStrike"
                [id]="'putStrike'"
                formControlName="putStrike"
                [readonly]="putStrike.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="upside.get('putParticipation') as putParticipation"
              class="form-group col-lg-2"
              [hidden]="putParticipation.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.upside.putParticipation"
                [id]="'putParticipation'"
                formControlName="putParticipation"
                [readonly]="putParticipation.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="upside.get('putSpreadStrike') as putSpreadStrike"
              class="form-group col-lg-2"
              [hidden]="putSpreadStrike.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.upside.putSpreadStrike"
                [id]="'putSpreadStrike'"
                formControlName="putSpreadStrike"
                [readonly]="putSpreadStrike.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
          </div>

          <ng-container formGroupName="barrier">
            <div [hidden]="upsideBarrier.disabled">
              <div class="form-row">
                <div
                  *ngIf="upsideBarrier.get('level') as level"
                  class="form-group col-lg-3"
                  [hidden]="level.disabled"
                >
                  <app-dc-input-number-percent-indicative-final
                    [label]="labels.payoff.participation.upside.barrier.level"
                    [id]="'level'"
                    formControlName="level"
                    [readonly]="level.readOnly"
                    defaultUnit="pct"
                    [minMaxIndicativeToggle]="true"
                    componentKey="c70cf2f3-4877-5f26-aeaf-bd62c2caa911"
                  ></app-dc-input-number-percent-indicative-final>
                </div>
                <div
                  *ngIf="upsideBarrier.get('obsFrequency') as obsFrequency"
                  class="form-group col-lg-2"
                  [hidden]="obsFrequency.disabled"
                >
                  <app-dc-select
                    [label]="
                      labels.payoff.participation.upside.barrier.obsFrequency
                    "
                    [labelId]="'obsFrequency'"
                    [items]="OBS_FREQUENCY"
                    closeOnSelect="true"
                    formControlName="obsFrequency"
                    [readonly]="obsFrequency.readOnly"
                    [clearSelection]="true"
                  ></app-dc-select>
                </div>
                <div
                  *ngIf="upsideBarrier.get('touchAndBreak') as touchAndBreak"
                  class="form-group col-lg-2"
                  [hidden]="touchAndBreak.disabled"
                >
                  <app-dc-select
                    [label]="
                      labels.payoff.participation.upside.barrier.touchAndBreak
                    "
                    [labelId]="'touchAndBreak'"
                    [items]="YES_NO"
                    closeOnSelect="true"
                    formControlName="touchAndBreak"
                    [readonly]="touchAndBreak.readOnly"
                    [clearSelection]="true"
                  ></app-dc-select>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="form-row">
            <div
              *ngIf="upside.get('rebateAmount') as rebateAmount"
              class="form-group col-lg-2"
              [hidden]="rebateAmount.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.upside.rebateAmount"
                [id]="'rebateAmount'"
                formControlName="rebateAmount"
                [readonly]="rebateAmount.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="upside.get('earlyTermination') as earlyTermination"
              class="form-group col-lg-2"
              [hidden]="earlyTermination.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.participation.upside.earlyTermination"
                [labelId]="'earlyTermination'"
                [items]="YES_NO"
                closeOnSelect="true"
                formControlName="earlyTermination"
                [readonly]="earlyTermination.readOnly"
                [clearSelection]="true"
              ></app-dc-select>
            </div>
            <div
              *ngIf="upside.get('rebateDate') as rebateDate"
              class="form-group col-lg-2"
              [hidden]="rebateDate.disabled"
            >
              <app-dc-date-input
                [label]="labels.payoff.participation.upside.rebateDate"
                [id]="'rebateDate'"
                placeholder=""
                formControlName="rebateDate"
                container="body"
              ></app-dc-date-input>
            </div>
            <div
              *ngIf="upside.get('rebateSettlementLag') as rebateSettlementLag"
              class="form-group col-lg-2 col-min"
              [hidden]="rebateSettlementLag.disabled"
            >
              <app-dc-select
                formControlName="rebateSettlementLag"
                [labelId]="'rebateSettlementLag'"
                [label]="labels.payoff.participation.upside.rebateSettlementLag"
                [items]="rebateSettlementLagItems"
                closeOnSelect="true"
                [searchable]="true"
                [FreeText]="true"
                [readonly]="rebateSettlementLag.readOnly"
                [clearSelection]="true"
              ></app-dc-select>
            </div>
          </div>
        </div>
        <hr />
      </ng-container>

      <ng-container formGroupName="downside" *ngIf="!downside.disabled">
        <div class="form-group">
          <div class="form-row">
            <div
              *ngIf="downside.get('downsideType') as downSidetype"
              class="form-group col-lg-2"
              [hidden]="downSidetype.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.participation.downside.downsideType"
                [labelId]="'downSidetype'"
                [items]="downSidetypeItems"
                closeOnSelect="true"
                formControlName="downsideType"
                [readonly]="downSidetype.readOnly"
              ></app-dc-select>
            </div>
            <ng-container *ngIf="productType.value">
              <div
                *ngIf="downside.get('strike') as strike"
                class="form-group col-lg-2"
                [hidden]="strike.disabled"
              >
                <app-dc-input-number-percent-indicative-final
                  [label]="labels.payoff.participation.downside.strike"
                  [id]="'strike'"
                  formControlName="strike"
                  [readonly]="strike.readOnly"
                  [defaultUnit]="productType.value === 'PRDC' ? 'abs' : 'pct'"
                ></app-dc-input-number-percent-indicative-final>
              </div>
            </ng-container>

            <div
              *ngIf="downside.get('leverageOptions') as leverageOptions"
              class="form-group col-lg-2"
              [hidden]="leverageOptions.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.participation.downside.leverageOptions"
                [id]="'leverageOptions'"
                formControlName="leverageOptions"
                [readonly]="leverageOptions.readOnly"
                [items]="LEVERAGE_OPTIONS"
                closeOnSelect="true"
                [clearSelection]="true"
              ></app-dc-select>
            </div>

            <div
              *ngIf="downside.get('floorStrike') as floorStrike"
              class="form-group col-lg-2"
              [hidden]="floorStrike.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.downside.floorStrike"
                [id]="'floorStrike'"
                formControlName="floorStrike"
                [readonly]="floorStrike.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
          </div>

          <ng-container formGroupName="barrier">
            <div [hidden]="downsideBarrier.disabled">
              <div class="form-row">
                <div
                  *ngIf="
                    downsideBarrier.get('knockInBarrier') as knockInBarrier
                  "
                  class="form-group col-lg-3"
                  [hidden]="knockInBarrier.disabled"
                >
                  <app-dc-input-number-percent-indicative-final
                    [label]="
                      labels.payoff.participation.downside.knockInBarrier
                    "
                    [id]="'knockInBarrier'"
                    formControlName="knockInBarrier"
                    [readonly]="knockInBarrier.readOnly"
                    defaultUnit="pct"
                    [minMaxIndicativeToggle]="true"
                    componentKey="49af57a9-93fd-5d38-8411-bfe962d32589"
                  ></app-dc-input-number-percent-indicative-final>
                </div>
                <div
                  *ngIf="
                    downsideBarrier.get(
                      'obsFrequency'
                    ) as participationObvsFrequency
                  "
                  class="form-group col-lg-2"
                  [hidden]="participationObvsFrequency.disabled"
                >
                  <app-dc-select
                    [label]="labels.payoff.participation.downside.obsFrequency"
                    [labelId]="'obvsFrequency2'"
                    [items]="OBS_FREQUENCY"
                    closeOnSelect="true"
                    formControlName="obsFrequency"
                    [readonly]="participationObvsFrequency.readOnly"
                    [clearSelection]="true"
                  ></app-dc-select>
                </div>
                <div
                  *ngIf="
                    downsideBarrier.get(
                      'touchAndBreak'
                    ) as participationTouchBreak
                  "
                  class="form-group col-lg-1"
                  [hidden]="participationTouchBreak.disabled"
                >
                  <app-dc-select
                    [label]="labels.payoff.participation.downside.touchAndBreak"
                    [labelId]="'touchBreak2'"
                    [items]="YES_NO"
                    closeOnSelect="true"
                    formControlName="touchAndBreak"
                    [readonly]="participationTouchBreak.readOnly"
                    [clearSelection]="true"
                  ></app-dc-select>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container formGroupName="base" *ngIf="!base.disabled">
        <div class="form-group base">
          <div class="form-row">
            <div
              *ngIf="base.get('type') as type"
              class="form-group col-lg-2"
              [hidden]="type.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.participation.base.type"
                [labelId]="'type'"
                [items]="baseTypeItems"
                closeOnSelect="true"
                formControlName="type"
                [readonly]="type.readOnly || baseTypeItems?.length === 1"
              ></app-dc-select>
            </div>
            <div
              *ngIf="base.get('initialCashAllocation') as initialCashAllocation"
              class="form-group col-lg-2"
              [hidden]="initialCashAllocation.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.base.initialCashAllocation"
                [id]="'initialCashAllocation'"
                formControlName="initialCashAllocation"
                [readonly]="initialCashAllocation.readOnly"
                defaultUnit="pct"
                lockDefault="true"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="
                base.get(
                  'initialInvestmentAllocation'
                ) as initialInvestmentAllocation
              "
              class="form-group col-lg-2"
              [hidden]="initialInvestmentAllocation.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="
                  labels.payoff.participation.base.initialInvestmentAllocation
                "
                [id]="'initialInvestmentAllocation'"
                formControlName="initialInvestmentAllocation"
                [readonly]="initialInvestmentAllocation.readOnly"
                defaultUnit="pct"
                lockDefault="true"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <ng-container
              *ngIf="productType.value === 'DISCOUNT_CERTIFICATE'"
              [ngTemplateOutlet]="strikeRef"
              [ngTemplateOutletContext]="{
                $implicit: base,
                lockDefault: false
              }"
            >
            </ng-container>
            <div
              *ngIf="base.get('bonusStrike') as bonusStrike"
              class="form-group col-lg-2"
              [hidden]="bonusStrike.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.base.bonusStrike"
                [id]="'bonusStrike'"
                formControlName="bonusStrike"
                [readonly]="bonusStrike.readOnly"
                mask="separator.2"
                thousandSeparator=","
                defaultUnit="pct"
                [lockDefault]="true"
                [minMaxIndicativeToggle]="true"
                componentKey="53bt62f1-860y-7b47-9f41-6c8ef03258f9"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="base.get('bonusAmount') as bonusAmount"
              class="form-group col-lg-2"
              [hidden]="bonusAmount.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.base.bonusAmount"
                [id]="'bonusAmount'"
                formControlName="bonusAmount"
                [readonly]="bonusAmount.readOnly"
                defaultUnit="pct"
                [decimalPlaces]="2"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="base.get('upperParticipation') as upperParticipation"
              class="form-group col-lg-2"
              [hidden]="upperParticipation.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.base.upperParticipation"
                [id]="'upperParticipation'"
                type="text"
                formControlName="upperParticipation"
                [readonly]="upperParticipation.readOnly"
                mask="separator"
                thousandSeparator=","
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="base.get('capped') as capped"
              class="form-group col-lg-1"
              [hidden]="capped.disabled"
            >
              <app-dc-select
                [label]="labels.payoff.participation.base.capped"
                [labelId]="'capped'"
                [items]="YES_NO"
                closeOnSelect="true"
                formControlName="capped"
                [readonly]="capped.readOnly"
              ></app-dc-select>
            </div>
            <div
              *ngIf="base.get('globalCap') as globalCap"
              class="form-group col-lg-2"
              [hidden]="globalCap.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.base.globalCap"
                [id]="'globalCap'"
                formControlName="globalCap"
                [readonly]="globalCap.readOnly"
                [defaultUnit]="globalCap.defaultUnit ?? 'pct'"
                customErrorMessage="Cap has to be greater than Discount Price"
              ></app-dc-input-number-percent-indicative-final>
            </div>
            <div
              *ngIf="base.get('issueAtDiscount') as issueAtDiscount"
              class="form-row col-lg-5 discount_certificate"
              [hidden]="issueAtDiscount.disabled"
            >
              <div class="form-group col-lg-5">
                <app-dc-toggle
                  id="issueAtDiscount"
                  label="Issue At Discount"
                  formControlName="issueAtDiscount"
                  [readonly]="issueAtDiscount.readOnly"
                  [helpText]="
                    issueAtDiscount.value
                      ? 'When enabled, Discount Price sets Issue Price'
                      : ''
                  "
                >
                </app-dc-toggle>
              </div>
              <div
                *ngIf="
                  base.get(
                    'initialLevelAsDenomination'
                  ) as initialLevelAsDenomination
                "
                class="form-group col-lg-6"
                [hidden]="initialLevelAsDenomination.disabled"
              >
                <app-dc-toggle
                  id="initialLevelAsDenomination"
                  label="Initial Level as Denomination"
                  formControlName="initialLevelAsDenomination"
                  [readonly]="initialLevelAsDenomination.readOnly"
                  [helpText]="
                    initialLevelAsDenomination.value
                      ? 'When enabled, Initial Level sets Denomination'
                      : ''
                  "
                >
                </app-dc-toggle>
              </div>
            </div>
            <div
              *ngIf="base.get('globalFloor') as globalFloor"
              class="form-group col-lg-2"
              [hidden]="globalFloor.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.base.globalFloor"
                [id]="'globalFloor'"
                formControlName="globalFloor"
                [readonly]="globalFloor.readOnly"
                defaultUnit="pct"
              ></app-dc-input-number-percent-indicative-final>
            </div>
          </div>
          <div class="form-row">
            <ng-container formGroupName="barrier">
              <div
                class="form-group col-lg-6"
                formArrayName="levelsAndInvestments"
                [hidden]="baseBarrierLevelsAndInvestments?.disabled"
              >
                <div
                  class="form-group levelsAndInvestments"
                  *ngFor="
                    let l of baseBarrierLevelsAndInvestments.controls;
                    let i = index;
                    let last = last;
                    let first = first
                  "
                >
                  <div class="form-row" [formGroupName]="i">
                    <div class="form-group col-lg-4">
                      <app-dc-input-number-percent-indicative-final
                        [label]="
                          labels.payoff.participation.base.barrier
                            .reallocationLevel | multilineLabel: i
                        "
                        [id]="'reallocationLevel'"
                        formControlName="level"
                        defaultUnit="pct"
                      ></app-dc-input-number-percent-indicative-final>
                    </div>
                    <div class="form-group col-lg-4">
                      <app-dc-input-number-percent-indicative-final
                        [label]="
                          labels.payoff.participation.base.barrier
                            .additionalInvestmentAllocation | multilineLabel: i
                        "
                        [id]="'investmentAllocation'"
                        formControlName="investmentAllocation"
                        defaultUnit="pct"
                        lockDefault="true"
                      ></app-dc-input-number-percent-indicative-final>
                    </div>
                    <div class="form-group col-lg-1 no-bottom-margin">
                      <app-dc-plus-minus
                        (minusClick)="deleteBarrierAndInvestmentLevel(i)"
                        (plusClick)="addBarrierAndInvestmentLevel()"
                        [showMinus]="i > DROP_BACK_MIN_BARRIER_LEVELS - 1"
                        [showPlus]="last"
                      >
                      </app-dc-plus-minus>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  baseBarrier.get(
                    'investmentLevelFixingType'
                  ) as investmentLevelFixingType
                "
                class="form-group col-lg-2 align-flex-start"
                [hidden]="investmentLevelFixingType.disabled"
                style="margin-left: -13.75%"
              >
                <app-dc-select
                  [label]="
                    labels.payoff.participation.base.barrier
                      .investmentLevelFixingType
                  "
                  [labelId]="'investmentLevelFixingType'"
                  [items]="INVESTMENT_LEVELS"
                  closeOnSelect="true"
                  formControlName="investmentLevelFixingType"
                  [readonly]="investmentLevelFixingType.readOnly"
                ></app-dc-select>
              </div>
              <div
                *ngIf="baseBarrier.get('level') as level"
                class="form-group col-lg-3 align-flex-start"
                [hidden]="level.disabled"
              >
                <app-dc-input-number-percent-indicative-final
                  [label]="labels.payoff.participation.base.barrier.level"
                  [id]="'level'"
                  formControlName="level"
                  [readonly]="level.readOnly"
                  defaultUnit="pct"
                  [lockDefault]="true"
                  [minMaxIndicativeToggle]="true"
                  componentKey="28fa71e9-630b-5f96-8e30-4a8ce92172e7"
                ></app-dc-input-number-percent-indicative-final>
              </div>
              <div
                *ngIf="baseBarrier.get('obsFrequency') as obsFrequency"
                class="form-group col-lg-2 align-flex-start"
                [hidden]="obsFrequency.disabled"
              >
                <app-dc-select
                  [label]="
                    labels.payoff.participation.base.barrier.obsFrequency
                  "
                  [labelId]="'obsFrequency'"
                  [items]="BASE_BARRIER_OBS_FREQUENCY"
                  closeOnSelect="true"
                  formControlName="obsFrequency"
                  [readonly]="obsFrequency.readOnly"
                  [clearSelection]="true"
                ></app-dc-select>
              </div>
              <div
                *ngIf="baseBarrier.get('touchAndBreak') as touchAndBreak"
                class="form-group col-lg-2 align-flex-start"
                [hidden]="touchAndBreak.disabled"
              >
                <app-dc-select
                  [label]="
                    labels.payoff.participation.base.barrier.touchAndBreak
                  "
                  [labelId]="'touchAndBreak'"
                  [items]="YES_NO"
                  closeOnSelect="true"
                  formControlName="touchAndBreak"
                  [readonly]="touchAndBreak.readOnly"
                  [clearSelection]="true"
                ></app-dc-select>
              </div>
            </ng-container>
          </div>
          <div class="form-row">
            <ng-container
              *ngIf="productType.value !== 'DISCOUNT_CERTIFICATE'"
              [ngTemplateOutlet]="strikeRef"
              [ngTemplateOutletContext]="{ $implicit: base, lockDefault: true }"
            >
            </ng-container>
            <div
              *ngIf="base.get('leverage') as leverage"
              class="form-group col-lg-2"
              [hidden]="leverage.disabled"
            >
              <app-dc-input-number-percent-indicative-final
                [label]="labels.payoff.participation.base.leverage"
                [id]="'leverage'"
                type="text"
                formControlName="leverage"
                [readonly]="leverage.readOnly"
                mask="separator"
                thousandSeparator=","
                defaultUnit="pct"
                [decimalPlaces]="2"
                [minMaxIndicativeToggle]="false"
              ></app-dc-input-number-percent-indicative-final>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <hr />
  </ng-container>

  <ng-container formGroupName="capitalBase">
    <div class="form-group callability" [hidden]="capitalBase?.disabled">
      <h3>Capital Base</h3>
      <div class="form-row">
        <div
          *ngIf="capitalBase.get('capitalBaseType') as capitalBaseType"
          class="form-group col-lg-2"
          [hidden]="capitalBaseType.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.capitalBase.capitalBaseType"
            [labelId]="'capitalBaseType'"
            [items]="capitalBaseTypeItems"
            closeOnSelect="true"
            formControlName="capitalBaseType"
            [readonly]="capitalBaseType.readOnly"
          ></app-dc-select>
        </div>
        <div
          *ngIf="capitalBase.get('capitalBase') as capitalBase"
          class="form-group col-lg-3"
          [hidden]="capitalBase.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.capitalBase.capitalBase"
            [id]="'capitalBase'"
            formControlName="capitalBase"
            [readonly]="capitalBase.readOnly"
            defaultUnit="pct"
            [minMaxIndicativeToggle]="true"
            componentKey="56d4855b-efe6-59d2-94ac-1025a8297c98"
          ></app-dc-input-number-percent-indicative-final>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container formGroupName="callability">
    <div class="form-group callability" [hidden]="callability?.disabled">
      <h3>{{ labels.payoff.callability.callability }}</h3>
      <div class="form-row">
        <div
          *ngIf="callability.get('callEventType') as callEventType"
          class="form-group col-lg-2"
          [hidden]="callEventType.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.callability.callEventType"
            [labelId]="'callEventType'"
            [items]="callEventTypeItems"
            closeOnSelect="true"
            formControlName="callEventType"
            [readonly]="
              callEventType.readOnly || callEventTypeItems.length === 1
            "
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="callability.get('frequency') as frequency"
          class="form-group col-lg-1"
          [hidden]="frequency.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.callability.frequency"
            [labelId]="'frequency2'"
            [items]="frequencyItems"
            closeOnSelect="true"
            formControlName="frequency"
            [readonly]="frequency.readOnly"
            [searchable]="true"
            [FreeText]="true"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="callability.get('deferredPeriods') as deferredPeriods"
          class="form-group col-lg-2"
          [hidden]="deferredPeriods.disabled"
        >
          <app-dc-input
            [label]="labels.payoff.callability.deferredPeriods"
            [id]="'deferredPeriods'"
            type="number"
            formControlName="deferredPeriods"
            [readonly]="deferredPeriods.readOnly"
          ></app-dc-input>
        </div>
        <div
          *ngIf="callability.get('lastPeriodCallable') as lastPeriodCallable"
          class="form-group col-lg-2"
          [hidden]="lastPeriodCallable.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.callability.lastPeriodCallable"
            [labelId]="'lastPeriodCallable'"
            [items]="YES_NO"
            closeOnSelect="true"
            formControlName="lastPeriodCallable"
            [readonly]="lastPeriodCallable.readOnly"
          ></app-dc-select>
        </div>
      </div>
      <div class="form-row">
        <ng-container formGroupName="barrier">
          <div
            *ngIf="callabilityBarrier.get('type') as barrierType"
            class="form-group col-lg-2"
            [hidden]="barrierType.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.callability.barrier.type"
              [labelId]="'barrierType'"
              [items]="barrierType.options ?? BARRIER_AMOUNT_WITH_CUSTOM"
              closeOnSelect="true"
              formControlName="type"
              [readonly]="barrierType.readOnly"
              [clearSelection]="true"
            ></app-dc-select>
          </div>
          <div
            *ngIf="callabilityBarrier.get('level') as barrierLevel"
            class="form-group col-lg-3"
            [hidden]="barrierLevel.disabled"
          >
            <app-dc-input-number-percent-indicative-final
              [label]="labels.payoff.callability.barrier.level"
              [id]="'barrierLevel'"
              formControlName="level"
              [readonly]="barrierLevel.readOnly"
              defaultUnit="pct"
              [minMaxIndicativeToggle]="true"
              componentKey="11b56925-1798-5318-8560-04f40b26d9b3"
            ></app-dc-input-number-percent-indicative-final>
          </div>
          <div
            *ngIf="callabilityBarrier.get('stepSize') as barrierStepSize"
            class="form-group col-lg-2"
            [hidden]="barrierStepSize.disabled"
          >
            <app-dc-input-number-percent-indicative-final
              [label]="labels.payoff.callability.barrier.stepSize"
              [id]="'barrierStepSize'"
              formControlName="stepSize"
              [readonly]="barrierStepSize.readOnly"
              defaultUnit="pct"
            ></app-dc-input-number-percent-indicative-final>
          </div>
          <div
            *ngIf="
              callabilityBarrier.get('obsFrequency') as callabilityObsFrequency
            "
            class="form-group col-lg-2"
            [hidden]="callabilityObsFrequency.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.callability.barrier.obsFrequency"
              [labelId]="'callabilityObsFrequency'"
              [items]="OBS_FREQUENCY"
              closeOnSelect="true"
              formControlName="obsFrequency"
              [readonly]="callabilityObsFrequency.readOnly"
              [clearSelection]="true"
            ></app-dc-select>
          </div>
          <div
            *ngIf="
              callabilityBarrier.get(
                'touchAndBreak'
              ) as callabilityTouchAndBreak
            "
            class="form-group col-lg-1"
            [hidden]="callabilityTouchAndBreak.disabled"
          >
            <app-dc-select
              [label]="labels.payoff.callability.barrier.touchAndBreak"
              [labelId]="'callabilityTouchAndBreak'"
              [items]="YES_NO"
              closeOnSelect="true"
              formControlName="touchAndBreak"
              [readonly]="callabilityTouchAndBreak.readOnly"
              [clearSelection]="true"
            ></app-dc-select>
          </div>
        </ng-container>
      </div>
      <div class="form-row">
        <div
          *ngIf="callability.get('amountType') as amountType"
          class="form-group col-lg-2"
          [hidden]="amountType.disabled"
        >
          <app-dc-select
            [label]="labels.payoff.callability.amountType"
            [labelId]="'amountType'"
            [items]="BARRIER_AMOUNT"
            closeOnSelect="true"
            formControlName="amountType"
            [readonly]="amountType.readOnly"
            [clearSelection]="true"
          ></app-dc-select>
        </div>
        <div
          *ngIf="callability.get('amount') as amount"
          class="form-group col-lg-2"
          [hidden]="amount.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.callability.amount"
            [id]="'amount'"
            formControlName="amount"
            [readonly]="amount.readOnly"
            defaultUnit="pct"
          ></app-dc-input-number-percent-indicative-final>
        </div>
        <div
          *ngIf="callability.get('amountStepSize') as amountStepSize"
          class="form-group col-lg-2"
          [hidden]="amountStepSize.disabled"
        >
          <app-dc-input-number-percent-indicative-final
            [label]="labels.payoff.callability.amountStepSize"
            [id]="'amountStepSize'"
            formControlName="amountStepSize"
            [readonly]="amountStepSize.readOnly"
            defaultUnit="pct"
          ></app-dc-input-number-percent-indicative-final>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #strikeRef let-base let-lockDefault="lockDefault">
  <div
    *ngIf="base.get('strike') as strike"
    class="form-group col-lg-2"
    [hidden]="strike.disabled"
  >
    <app-dc-input-number-percent-indicative-final
      [label]="strike.label ?? labels.payoff.participation.base.strike"
      [id]="'strike'"
      type="text"
      [formControl]="strike"
      [readonly]="strike.readOnly"
      mask="separator"
      thousandSeparator=","
      [defaultUnit]="strike.defaultUnit ?? 'pct'"
      [lockDefault]="lockDefault"
      [customErrorMessage]="
        !lockDefault ? 'Cap has to be greater than Discount Price' : ''
      "
      [minMaxIndicativeToggle]="false"
      #strikeInputRef
    ></app-dc-input-number-percent-indicative-final>
  </div>
</ng-template>
